module.exports = __webpack_public_path__ + "static/incomplet-433c3a3f116e9a7dad922cbbdd86b704.jpg";